import { useContext, useEffect } from "react";
import "./style.css";
import Footer from "../../components/Footer/Footer";
import { NavLink } from "react-router-dom";
import { CompraContext } from "../../context/CompraContext";
import Lottie from "lottie-react";
import json from "../../images/animation_lnypqqsr.json";
import { PatchNegocio } from "../../services/crmService";
import { ObterProdutoExpress } from "../../data/crmProdutoExpress";
import { crmEstagioExpress } from "../../data/crmEstagioExpress";
import CardCertificadoSelecionado from "../../components/Card/CardCertificadoSelecionado";
import cartaoleitora from "../../images/Certificado/cartaoleitora.svg";
import cartao from "../../images/Compra/cartao.svg";
import token from "../../images/Certificado/token.svg";
import file from "../../images/Certificado/file.webp";
import certificadoescudo from "../../images/Certificado/certificadoescudo.webp";

function CompraFinalizada() {
  const { ProdutoCompra, transactionId, Cadastro } = useContext(CompraContext);
  const dataCardSelecionado = {
    icone: verificaIcone(ProdutoCompra?.resumo),
    valor: ProdutoCompra?.anos[0].valor.toFixed(2),
    titulo: ProdutoCompra?.descricaoResumida.split("-")[0],
    modelo: ProdutoCompra?.descricaoResumida.split("-")[0].split(" ")[1],
    formato: ProdutoCompra?.descricaoResumida.split("-")[1],
    validade: ProdutoCompra?.anos[0].descricao,
  };

  useEffect(() => {
    try {
      window.dataLayer.push({
        event: "venda_certificado", // nome do evento
        transaction_id: transactionId, // ID da transação
        value: ProdutoCompra.anos[0].valor, // valor da compra
        currency: "BRL", // moeda
      });
    } catch (error) {
      console.log("Erro ao enviar dados para o Google Tag Manager");

      // não é o ideal, mas é a forma de encontrar algum erro caso o evento não seja enviado
      const negocioDto = {
        idEstagioVenda: crmEstagioExpress.NegocioPerdido, // negocio perdido
        pipeline: "PIPELINE_EXPRESS",
        produto: ObterProdutoExpress(Number(ProdutoCompra.anos[0].sku)),
        observacao:
          "Erro no envio do evento de compra para o Google Tag Manager",
      };
      PatchNegocio(negocioDto, Cadastro.email.trim());
    }
  }, []);

  function verificaIcone(item) {
    if (item?.includes("Cartão + Leitora")) {
      return cartaoleitora;
    } else if (item?.includes("Cartão")) {
      return cartao;
    } else if (item?.includes("Token")) {
      return token;
    } else if (item?.includes("Arquivo")) {
      return file;
    } else if (item?.includes("Nuvem")) {
      return certificadoescudo;
    } else {
      return certificadoescudo;
    }
  }

  return (
    <>
      <div className="compra-finalizada">
        <CardCertificadoSelecionado
          image={dataCardSelecionado.icone}
          modelo={dataCardSelecionado.modelo}
          formato={dataCardSelecionado.formato}
          titulo={dataCardSelecionado.titulo}
          validade={dataCardSelecionado.validade}
          valor={dataCardSelecionado.valor}
        />

        <div className="container-compra-finalizada">
          <h3>Transação Aprovada!</h3>
          <h4>
            Você será redirecionado para a nossa parceira Certificadora Gfis
            para concluir o seu processo!
          </h4>
          <p>
            <i>
              Em breve, um agente Gfis vai entrar em contato com você via
              telefone, whatsapp ou e-mail para prosseguir com os procedimentos
              de validação online.
            </i>
          </p>
          <div style={{ width: "200px", height: "200px" }}>
            <Lottie animationData={json} loop={false} />
          </div>
          <NavLink to="/">
            <button className="btn-primario">Voltar para a home</button>
          </NavLink>
        </div>
      </div>
      <Footer footerCertificado={true} />
    </>
  );
}

export default CompraFinalizada;
